// import Search from "../Search/Search";
const en = {
  dir: "ltr",
  langs: {
    en: "en",
    ar: "ar",
  },
  scrollTop: "Top",
  textAlign: "left",
  navbar: {
    navLogo: "Trade Gate",
    navLinks: {
      link1: "Trade and Markets",
      link2: {
        title: "Country Profile",
        subLinks: {
          link1: "All Countries",
          link2: "Add Country",
        },
      },
      link3: "Company Profile",
    },
  },
  mainWebPageHead: "CONSULTING",
  searchControl: {
    title: "BEST COUNTRIES FOR TRADE",
    desc: "Identify the<strong> top partner countries</strong> for importing or exporting any given product (described by its Harmonised System classification number) with the Best Countries for Trade wizard.Source : UN Comtrade To learn more about coverage and limitations of the data provided please consult:",
    searchForm: {
      labelHead: "You want to:",
      labelInput1: "Export",
      labelInput2: "Import",
      industryHolder: "Choose your industry",
      sectorHolder: "Choose your sector",
      searchInput: "Search",
    },
  },
  tabs: {
    tabsBtn: "Trade and Markets",
    tab1: "Discover your product markets",
    tab2: "Trade development",
  },
  addCountry: {
    title: "Add Country",
  },
  editCountry: {
    title: "Edit Country",
  },
  AllCountries: {
    title: "All Countries",
  },
  CompanyProfile: {
    title: "Company Profile",
  },
  footer: {
    mainFooter: {
      title: "Let us improve your business!",
      desc: "Morbi eget augue bibendum, faucibus mi et, scelerisque mauris. Aenean dapibus massa a sapien hendrerit molestie vitae eget leo. Etiam tristique urna nibh, nec rutrum mi eleifend facilisis. Quisque semper ante metus. In in convallis urna, ut aliquam.",
      btn: "Contact us today",
    },
    subFooter: {
      copyRights: "&copy; The7 Business - 2020. All rights reserved.",
    },
  },
};
export default en;
